import { render, staticRenderFns } from "./adPositionOptions.vue?vue&type=template&id=e60856d8&"
import script from "./adPositionOptions.vue?vue&type=script&lang=js&"
export * from "./adPositionOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e60856d8')) {
      api.createRecord('e60856d8', component.options)
    } else {
      api.reload('e60856d8', component.options)
    }
    module.hot.accept("./adPositionOptions.vue?vue&type=template&id=e60856d8&", function () {
      api.rerender('e60856d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/adPositionOptions.vue"
export default component.exports